{
  "es": {
    "ticket": {
      "actions": {
        "assignCustomer": "Completar trámite",
        "bulk_assign_new_emp": "Asignar nuevo responsable en bloque",
        "close": "Cerrar",
        "create_new": "Crear nueva conversación",
        "customer_new_ticket": "Nueva conversación",
        "delete": "Eliminar",
        "edit": "Editar",
        "existing_conversation": "Conversación existente",
        "goToConversation": "Ir a la conversación",
        "move_to_existing": "Mover mensaje a una conversación existente",
        "new": "Conversación",
        "new_aria_label": "Iniciar una nueva conversación",
        "new_conversation": "Nueva conversación",
        "reopen": "Reabrir",
        "selectResponsible": "Seleccionar responsable",
        "selectUnit": "Seleccionar unidad",
        "show": "Mostrar",
        "startNew": "Iniciar una nueva conversación"
      },
      "attributes": {
        "status": "Estado",
        "statuses": {
          "closed": "Cerrada",
          "feedback": "Esperando respuesta",
          "ongoing": "En curso",
          "open": "Abierta"
        },
        "title": "Título"
      },
      "editor": {
        "tooltips": {
          "bold": "Negrita",
          "bulletList": "Lista con viñetas",
          "highlight": "Resaltar",
          "italic": "Cursiva",
          "link": "Enlace",
          "orderedList": "Lista numerada",
          "redo": "Rehacer",
          "strike": "Tachado",
          "textColor": "Color de texto",
          "underline": "Subrayado",
          "undo": "Deshacer",
          "unlink": "Quitar enlace"
        }
      },
      "labels": {
        "addFile": "Añadir archivo",
        "additionalQuestion": "¿Tienes alguna pregunta adicional?",
        "all": "Todas",
        "allProjects": "Todos los proyectos",
        "allUnits": "Todas las unidades",
        "assign_conversations": "Asignar conversaciones de",
        "bulk_assign_new_emp_warning": "Esta actualización también incluirá las conversaciones vinculadas a decisiones o a posventa. En las decisiones relacionadas (de estas conversaciones afectadas), el empleado responsable también se actualizará.",
        "cantChangeResponsibleAftercare": "Esta conversación está vinculada a una incidencia de posventa. Cambia el responsable allí.",
        "cantChangeResponsibleDecision": "Esta conversación está vinculada a una decisión. Cambia el responsable allí.",
        "cantDelete": "Esta conversación pertenece a una decisión y no se puede eliminar.",
        "cantEdit": "Esta conversación pertenece a una decisión. Edítala desde la decisión",
        "changeResponsible": "Modificar",
        "change_responsible": "Cambiar responsable de las conversaciones",
        "clientWillRespondSoon": "Te responderemos lo antes posible",
        "contact": "Contacto",
        "contactPerson": "Tu persona de contacto",
        "contactPersonWithName": "Tu contacto de {name}",
        "conversation_title": "Título de la conversación",
        "conversations": "Conversaciones",
        "create_ticket": "Crear conversación",
        "customer": "Cliente",
        "customers": "Clientes",
        "decision": "¿Qué decisión?",
        "decisionConversation": "Decisión",
        "decisionConversations": "Decisiones",
        "disabled_unit": "Esta unidad se ha desactivado. No se pueden enviar mensajes.",
        "documentAddedBy": "de",
        "documents": "Documentos",
        "email_forwarding": "Reenvío de correo",
        "employee": "Empleado",
        "export_conversation": "Exportar conversación",
        "files": "Archivos",
        "filter": "Filtro",
        "inbound_by": "Recibido por {name}",
        "inbound_emails": "Correos entrantes",
        "info": "¿Tienes una pregunta y no encuentras la respuesta en la sección {faq_route}? ¡Pregúntala aquí! Intenta agrupar tus preguntas en temas de conversación claros, por ejemplo, «Especificaciones». ",
        "keywords": "Buscar contenido",
        "lastMessage": "Último mensaje",
        "message": "Mensaje",
        "message_placeholder": "Escribe tu mensaje aquí...",
        "message_subtitle": "Describe tu pregunta o tu problema",
        "messaged_at_nulls_first_asc": "Actividad más antigua",
        "messaged_at_nulls_last_desc": "Última actividad",
        "myProjects": "Mis proyectos",
        "myTickets": "Mis conversaciones",
        "myTicketsTooltip": "Mostrar solo las conversaciones en las que eres el responsable",
        "name_lower_asc": "Título A -> Z",
        "name_lower_desc": "Título Z -> A",
        "newConversation": "Nueva conversación",
        "newMessage": "Nuevo mensaje",
        "newMessages": "Mensajes nuevos",
        "newWithPartner": "Ziggu y {partner}",
        "newWithZiggu": "Solo Ziggu",
        "noCustomer": "Todavía no hay ningún cliente asignado ni invitado",
        "noCustomerAssignedToUnit": "No hay ningún cliente asignado a esta unidad. ¿Quieres continuar?",
        "noCustomerAssignedToUnitExplainer": "Ten en cuenta que tendrás que seleccionar otro destinatario.",
        "noCustomerAssignedToUnit_SUP": "No hay ningún cliente asignado a este proyecto. ¿Quieres continuar?",
        "noCustomerInvited": "El cliente asignado a esta unidad todavía no ha sido invitado. ¿Quieres continuar?",
        "noFiles": "Todavía no se ha subido ningún archivo",
        "noMessagesYet": "Todavía no hay mensajes",
        "noTickets": "No hay conversaciones",
        "no_messages": "La conversación no tiene mensajes",
        "notSeenYet": "Todavía no visto",
        "notYetDetermined": "Todavía no determinado",
        "note": "Nota",
        "note_placeholder": "Escribe solo para los miembros del equipo. Escribe {'@'} para mencionar a un miembro del equipo y se le notificará.",
        "onlySelect": "Mostrar solo",
        "orNewTicket": "O abre una nueva sobre otro tema",
        "otherTickets": "Otras conversaciones del cliente",
        "participants": "1 participante | {count} participantes",
        "partner": "Colaborador",
        "partnerGroup": "¿Con quién quieres hablar?",
        "partnersDecision": "Colaboradores de la decisión",
        "pendingContactPerson": "Tu persona de contacto responderá lo antes posible",
        "pendingTickets": "Mensajes nuevos",
        "project": "Proyecto",
        "read": "Leído",
        "remove_inbound_email": "¿Quitar {email}?",
        "reply": "Responder",
        "reply_placeholder": "Escribe a todos",
        "responsible": "Responsable",
        "search": "Buscar",
        "search_conversation": "Buscar",
        "seen": "Visto",
        "seenAll": "todos",
        "seenBy": "Visto por {name}",
        "selectLevel": "Seleccionar nivel",
        "selectUnit": "Seleccionar unidad",
        "show": "Mostrando",
        "showFiles": "Mostrar archivos",
        "showTicketsFor": "Mostrar conversaciones de",
        "showingAll": "Todas las conversaciones",
        "sort": "Ordenar por",
        "startConversation": "Iniciar una nueva conversación",
        "startConversationForProject": "Iniciar una nueva conversación en el proyecto ",
        "startNewConversation": "Iniciar una nueva conversación",
        "subject": "Asunto",
        "subject_subtitle": "Descríbelo en pocas palabras",
        "teamMember": "Empleado",
        "ticketClosed": "Esta conversación se ha cerrado.",
        "ticketClosedByResponsible": "Esta conversación ha sido cerrada por {responsible}",
        "ticketClosedCustomer": "Si tienes otra pregunta, abre una nueva conversación.",
        "ticketClosedEmployee": "Si quieres reabrir la conversación, cambia el estado de arriba.",
        "ticket_category": "Categoría",
        "tickets_all_projects": "Conversaciones de todos los proyectos",
        "to": "a",
        "unit": "Unidad",
        "unit_name_lower_asc": "Unidad A -> Z",
        "unit_name_lower_desc": "Unidad Z -> A",
        "unread": "Sin leer",
        "upload_files": "1 archivo pendiente | {count} archivos pendientes",
        "warning_move_message_to_new_ticket": "Este mensaje se moverá a una conversación normal, que no estará vinculada a ninguna decisión ni incidencia.",
        "withMentions": "Mencionado en",
        "withMessages": "Con mensajes",
        "writeMessageToBecomeResponsible": "Escribe un mensaje para convertirte en responsable",
        "you": "Tú"
      },
      "messages": {
        "redirect_decision": "Esta conversación forma parte de una decisión. Haz clic aquí para verla.",
        "redirect_issue": "Esta conversación forma parte de posventa. Haz clic aquí para ir a posventa.",
        "redirect_link": "Ver detalles"
      },
      "navigation": {
        "backToTickets": "Volver"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Intenta agrupar tus preguntas en temas de conversación generales, por ejemplo, «Especificaciones».",
            "title": "¿Tienes una pregunta? ¡Pregúntala aquí!"
          },
          "none": {
            "title": "No se han encontrado conversaciones"
          }
        },
        "employees": {
          "new": {
            "subtitle": "¡Inicia tu primera conversación con alguien!",
            "title": "¿Tienes algo que preguntar?"
          },
          "none": {
            "subtitle": "Ajusta los filtros en la parte superior de la página o empieza a seguir un proyecto para encontrar las conversaciones relacionadas",
            "subtitle_aftercare": "Haz clic en los 3 puntos de una incidencia para iniciar una conversación",
            "title": "No se han encontrado conversaciones"
          }
        }
      },
      "toasts": {
        "responsible_bulk_update_started": "Se está cambiando el responsable. Puede tardar unos minutos."
      },
      "validation": {
        "mustBeMaximum": "El asunto debe tener menos de {number} caracteres.",
        "needCustomer": "Selecciona un cliente",
        "needMessage": "Mensaje obligatorio",
        "needName": "Título obligatorio",
        "needResponsible": "Selecciona un responsable",
        "needSubject": "Asunto obligatorio",
        "needUnit": "Selecciona una unidad"
      }
    }
  }
}
